import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ["You're over 55 and feel joint pain is limiting your life", "You're tired of taking anti-inflammatories without solving the root cause", 'You want a natural, affordable, science-based solution', "You're willing to spend 20 minutes a day in your kitchen for 7 days", 'You want to understand your body, not just medicate it'];
const notFor = ["You're looking for a magic pill that works without any habit change", "You're not willing to dedicate 20 minutes daily to preparing your food", 'You have a severe medical condition without active medical supervision', 'You expect results without following the complete protocol'];
export function WhoItsFor() {
  return <section className="bg-white py-12 md:py-16 px-4 sm:px-6 lg:px-8" data-id="element-264">
      <div className="max-w-6xl mx-auto" data-id="element-265">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-266">
          {/* Left Column - IS For */}
          <FadeIn delay={0.1} data-id="element-267">
            <div className="bg-sage-light/10 p-8 rounded-2xl border border-sage-green/20 h-full" data-id="element-268">
              <h3 className="text-2xl font-serif font-bold text-forest-green mb-8 text-center" data-id="element-269">
                This Manual IS For You If:
              </h3>
              <div className="space-y-6" data-id="element-270">
                {isFor.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-271">
                    <CheckCircle2 className="w-6 h-6 text-sage-green flex-shrink-0 mt-0.5" data-id="element-272" />
                    <p className="text-gray-800 font-medium" data-id="element-273">{item}</p>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          {/* Right Column - NOT For */}
          <FadeIn delay={0.3} data-id="element-274">
            <div className="bg-alert-red/30 p-8 rounded-2xl border border-alert-red-border/20 h-full" data-id="element-275">
              <h3 className="text-2xl font-serif font-bold text-alert-red-text mb-8 text-center" data-id="element-276">
                This Manual Is NOT For You If:
              </h3>
              <div className="space-y-6" data-id="element-277">
                {notFor.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-278">
                    <XCircle className="w-6 h-6 text-alert-red-text flex-shrink-0 mt-0.5" data-id="element-279" />
                    <p className="text-gray-800 font-medium" data-id="element-280">{item}</p>
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}